<h2 [innerHtml]="text"></h2>

<div class="bee-button" (click)="close()">Stäng</div>